import { getGlobalEventMergeId } from '../../_common/client/tracking';
import { BaseComponent } from '../../base-component';
import { benefitEvents } from '@otto-ec/nexus-registry/benefit/events';
import { Unset } from '@otto-ec/global-resources/nexus';
import { EFFECTIVE_PRICE_CHANGED_TOPIC, getRenderedEffectivePrice } from './effective-price';

export class PriceComponent extends BaseComponent {
    public rootSelector = '.js_pdp_price';
    private benefitListenerUnset?: Unset | null;

    public async init(): Promise<void> {
        return;
    }

    public async onHtmlLoaded(): Promise<void> {
        this.benefitListenerUnset?.();

        if (!this.isPresent()) {
            return;
        }

        const rootElement = this.getRootElement();
        const variationId = rootElement.dataset.variationId || '';
        this.registerOnFT9BenefitEvent(rootElement, variationId);
        this.renderBenefitComponent(variationId);
    }

    private renderBenefitComponent(variationId: string): void {
        const isSoldOut = this.getRootElement().dataset.isSoldOut === 'true';
        if (isSoldOut) return;

        const benefitTargetElement = this.getChildElement('.js_pdp_price__benefit-target');
        const productId = this.getRootElement().dataset.productId || '';
        const eventMergeIdAttribute = o_product.state.isVariationChanged ? `event-merge-id="${getGlobalEventMergeId()}"` : '';
        const benefitIdAttribute = benefitTargetElement.dataset.benefitId ? `benefit-id="${benefitTargetElement.dataset.benefitId}"` : '';
        benefitTargetElement.innerHTML = `<ft9-detailview-v1 team="ft5" feature="pdpDetailview" variation-id="${variationId}" product-id="${productId}" ${benefitIdAttribute} ${eventMergeIdAttribute} add-padding></ft9-detailview-v1>`;
    }

    private registerOnFT9BenefitEvent(rootElement: HTMLElement, variationId: string): void {
        this.benefitListenerUnset = benefitEvents.active.subscribe(benefit => {
            if (!rootElement.isConnected || !benefit.variationId || benefit.variationId !== variationId) {
                return;
            }

            const currentPriceElement = this.getEffectivePriceElement();
            const currentBenefitId = currentPriceElement?.dataset.benefitId;
            const effectiveBenefitId = benefit.active ? benefit.id : 'original';

            if (!benefit.active && currentBenefitId !== benefit.id) {
                return;
            }

            const effectivePriceElement = this.findPriceElement(effectiveBenefitId);
            if (!effectivePriceElement || this.readPrice(effectivePriceElement) === undefined) {
                return;
            }

            this.renderEffectiveBenefit(effectiveBenefitId, effectivePriceElement);
            this.notifyPriceChanged();
        });
    }

    private notifyPriceChanged(): void {
        const effectivePrice = getRenderedEffectivePrice();
        if (effectivePrice) {
            o_global.eventQBus.emit(EFFECTIVE_PRICE_CHANGED_TOPIC, effectivePrice);
        }
    }

    private renderEffectiveBenefit(effectiveBenefitId: string, effectivePriceElement: HTMLElement): void {
        const benefitElements = this.getChildElements(
            '.js_pdp_price__discount [data-benefit-id], .js_pdp_price__tag[data-benefit-id], .js_pdp_price__onex-e3874-financing-detail[data-benefit-id]'
        );

        benefitElements.forEach(element => {
            element.classList.toggle('pl_hidden', element.dataset.benefitId !== effectiveBenefitId);
        });

        const hasActiveBenefit = effectiveBenefitId !== 'original';
        if (hasActiveBenefit) {
            /*                                                                                                                 */
            this.getRootElement().querySelector('.js_pdp_price__discount-highlight')?.classList.add('pdp_price__discount-highlight--sale');
        }

        const effectivePrice = this.readPrice(effectivePriceElement);
        this.getRootElement()
            .querySelector('.js_pdp_price__installment-wrapper')
            ?.classList.toggle('pl_hidden', effectivePrice === 0);
    }

    private getEffectivePriceElement(): HTMLElement | undefined {
        return this.getRootElement().querySelector<HTMLElement>('.js_pdp_price__tag:not(.pl_hidden)') || undefined;
    }

    private findPriceElement(benefitId: string): HTMLElement | undefined {
        return this.getChildElements<HTMLElement>('.js_pdp_price__tag[data-benefit-id]').find(
            element => element.dataset.benefitId === benefitId
        );
    }

    private readPrice(element: HTMLElement): number | undefined {
        const serializedPrice = element.dataset.priceCents;
        if (serializedPrice === undefined || serializedPrice === '') {
            return undefined;
        }

        const price = Number(serializedPrice);
        return Number.isFinite(price) ? price : undefined;
    }
}
